// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {
    getTypeOfClothing,
    insertTypeOfClothing,
    typeOfClothingSelector,
    updateTypeOfClothing,
} from "./typeOfClothingSlice";

import {Colors} from "../../../assets/Colors";

const TypeOfClothingPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const typeOfClothing = useSelector(typeOfClothingSelector);

    useEffect(() => {
        dispatch(
            getTypeOfClothing({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && typeOfClothing.isGetSuccess && !typeOfClothing.isGetFetching) {
            let calc = typeOfClothing?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = typeOfClothing.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (search === "" && typeOfClothing.isGetSuccess && !typeOfClothing.isGetFetching) {
            let calc = typeOfClothing?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = typeOfClothing.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !typeOfClothing?.isGetFetching &&
            typeOfClothing.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = typeOfClothing?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = typeOfClothing.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getTypeOfClothing({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (typeOfClothing.isGetSuccess) {
                alertService.success(typeOfClothing.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getTypeOfClothing({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (typeOfClothing.isUpdateSuccess) {
                alertService.success(typeOfClothing.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateTypeOfClothing({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetTypeOfClothing(params) {
    //   return dispatch(getTypeOfClothing(params));
    // }

    function handleInsertTypeOfClothing(param) {
        setInsertFetch(true);
        const params = {
            TypeOfClothingName: param.inputOneValue,
        };

        dispatch(insertTypeOfClothing(params));
    }

    function handleUpdateTypeOfClothing(param) {
        setUpdateFetch(true);

        const params = {
            TypeOfClothingName: param.inputOneValue,
            TypeOfClothingID: currentData.TypeOfClothingID,
            status: param.status,
        };
        dispatch(updateTypeOfClothing(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getTypeOfClothing(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getTypeOfClothing(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = typeOfClothing.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? typeOfClothing.count : newCount,
            search: search,
        };
        dispatch(getTypeOfClothing(params));

        setPage(1);
        setCount(newCount === "-1" ? typeOfClothing.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>
                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="TypeOfClothing"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master TypeOfClothing"
                                tableData={typeOfClothing.data}
                                colOneTitle="ID"
                                colOneData="TypeOfClothingID"
                                colTwoTitle="Nama TypeOfClothing"
                                colTwoData="TypeOfClothingName"
                                status="Status"
                                fetching={typeOfClothing.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah TypeOfClothing"
                        inputOneTitle="Nama TypeOfClothing"
                        inputOneValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertTypeOfClothing}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.TypeOfClothingID}
                        modal={handleModal}
                        modalTitle="Ubah TypeOfClothing"
                        inputOneTitle="Nama TypeOfClothing"
                        inputOneValue={currentData.TypeOfClothingName}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateTypeOfClothing}
                    />
                )}
            </div>
        );
    }
};

export default TypeOfClothingPage;
